export enum CANVAS_TRANSITION_CONNECTION_TYPES {
  COPY_HOVERED = 'COPY_HOVERED',
  COPY_NOT_HOVERED = 'COPY_NOT_HOVERED',
  SOLID = 'SOLID',
  DASHED = 'DASHED',
}
